export default "__VITE_ASSET__CNGzCDdj__"